export enum ProfileTranslations {
    ADMIN = "Administrador",
    USER = "Usuário",
    MANAGER = "Gerente",
    OWNER = "Proprietário",
}
